// Define initial state as a constant for reusability
const initialState = {
  customReportLink: null,
  reportType: null,
  products: [],
  productGroups: [],
  dateTo: null,
  dateFrom: null,
  ecus: [],
  dtcs: [],
  keep: [],
  ignore: [],
  include: [],
  exclude: [],
  includeTimeBefore: null,
  includeTimeAfter: null,
  excludeTimeBefore: null,
  excludeTimeAfter: null
}

const streamlineReport = {
  namespaced: true,

  state: () => ({
    jsonInBackend: {
      data: null
    },
    selected: { ...initialState },
    loaded: { ...initialState }
  }),

  mutations: {
    SET_SELECTED(state, { propName, value }) {
      state.selected[propName] = value
    },

    SET_JSON_BACKEND(state, { propName, value }) {
      if (propName in state.jsonInBackend) {
        state.jsonInBackend[propName] = value
      }
    },

    OVERWRITE_SELECTED(state, newVal) {
      // Merge new values with default structure to ensure consistency
      state.selected = {
        ...initialState,
        ...newVal
      }, state.loaded = {
          ...initialState,
          ...newVal
        }

    },

    RESET_SELECTION_STATE(state) {
      state.selected = { ...initialState }
    }
  },

  getters: {
    getAllSelections: state => ({ ...state.selected}),

    getloadedJSONSelections: state => ({ ...state.loaded}),
  }
  ,

  actions: {
    loadStateFromFile({ commit }, data) {
      try {
        commit('OVERWRITE_SELECTED', data)
         return Promise.resolve()
      } catch (error) {
        console.error('Error loading state:', error)
        return Promise.reject(error)
      }
    },

    updateSelection({ commit }, payload) {
      try {
        commit('SET_SELECTED', payload)
        return Promise.resolve()
      } catch (error) {
        console.error('Error updating selection:', error)
        return Promise.reject(error)
      }
    },

    reset({ commit }) {
      try {
        commit('RESET_SELECTION_STATE')
        return Promise.resolve()
      } catch (error) {
        console.error('Error resetting state:', error)
        return Promise.reject(error)
      }
    },

  }
}

export default streamlineReport
